import { Box, Collapse, useControllableState } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';

import { AccordionButton, AccordionButtonProps } from './AccordionButton';

export type AccordionItemProps = AccordionButtonProps & {
  isDefaultOpen?: boolean;
  isOpen?: boolean;
  onOpen?: (newState: boolean) => void;
  isDisabled?: boolean;
};

export function AccordionItem({
  children,
  onOpen,
  isOpen: isControllableOpen,
  isDefaultOpen = false,
  isDisabled = false,
  ...accordionButtonProps
}: PropsWithChildren<AccordionItemProps>) {
  const [isOpen, setOpen] = useControllableState<boolean>({
    value: isControllableOpen,
    defaultValue: isDefaultOpen,
    onChange: onOpen,
  });

  return (
    <Box display="block" width="100%" data-testid="accordion-item">
      <AccordionButton
        isOpen={isOpen}
        onClick={() => setOpen(!isOpen)}
        isDisabled={isDisabled}
        {...accordionButtonProps}
      />
      <Collapse in={isOpen}>
        <Box borderRadius="radius.8" mt="space.4" p="space.16" bg="gray.2">
          {children}
        </Box>
      </Collapse>
    </Box>
  );
}
